import * as $ from "jquery";
import { $body } from "../../Core/Body";

export default class NewsletterValidation
{
    readonly Selector: any;

    constructor()
    {
        this.validate = this.validate.bind(this);
        this.Selector = {
            FORM: '#newsletter-form'
        }
    }

    public validate()
    {

        $(this.Selector.FORM).validate({
            ignore: '',
            rules: {
                newsletter_agreement: {required: true},
                email: {required: true, email: true}
            },
            errorPlacement: function(error, element) {
                $(element).parent().prepend(error)
            },
            submitHandler: function (form) {
                if (grecaptcha.getResponse()) {
                    form.submit();
                }else{
                    grecaptcha.reset();
                    grecaptcha.execute();
                }           
            }         
        });
    }

    public onLoad()
    {
        $body.on( "click", this.validate );
    }

    public onChange()
    {
        $( window ).on( "change", this.validate );
    }
}
import * as $ from "jquery";
import { $body } from "../../Core/Body";

export default class NewsletterValidation
{
    readonly Selector: any;

    constructor()
    {
        this.validate = this.validate.bind(this);
        this.Selector = {
            FORM: '#newsletter-form'
        }
    }

    public validate()
    {

        $(this.Selector.FORM).validate({
            ignore: '',
            rules: {
                newsletter_agreement: {required: true},
                email: {required: true, email: true}
            },
            errorPlacement: function(error, element) {
                $(element).parent().prepend(error)
            },
            submitHandler: function (form) {
                if (grecaptcha.getResponse()) {
                    form.submit();
                }else{
                    grecaptcha.reset();
                    grecaptcha.execute();
                }           
            }         
        });
    }

    public onLoad()
    {
        $body.on( "click", this.validate );
    }

    public onChange()
    {
        $( window ).on( "change", this.validate );
    }
}
